import React, { useState } from 'react';
import './placements.css';
import C2wPlacementCard from '../../../common/C2wHome/placementCard.js/placementCard';
import placementData from './placements.json';
import C2wiInView from '../../../components/C2wHome/courses/inView/inView';
import { Helmet } from 'react-helmet';

function C2wPlacemets() {
    const [flag, setFlag] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleDetails = (index) => {
        setSelectedIndex(index);
        setFlag(true);
    };

    const handleFlag = (flag) => {
        setFlag(flag);
    };

    return (
        <div className='C2wTestimonials_ctn_route'>
            <Helmet>
                <title>Placements of Core2web Students</title>
                <meta name="description" content="Core2web Provides 100% Placement Guidance" />
                <meta name="robots" content="index, follow" />
            </Helmet>

            {/* Placement Cards Grid */}
            <div className='C2wTestimonials_ctn_sroller' style={{ paddingTop: '90px' }}>
                <div className='C2wPlacementsHeading_ctn_hld'>
                    <div className='C2wPlacementsHeading_ctn'>
                        <span className='C2wPlacementsHeadingSpan'>{'12500+ '}</span>
                        {'Students Placed in'}
                        <span className='C2wPlacementsHeadingSpan'>{' 180+ '}</span>
                        {'Companies'}
                    </div>
                </div>
                <div className='C2wPlacemets_ctn_placementsCards_htder'>
                    {placementData?.placements?.map((url, index) => (
                        <C2wPlacementCard
                            key={index}
                            onClick={() => handleDetails(index)}
                            index={index}
                            url={`/assets/images/placements/${url}`}
                        />
                    ))}
                </div>
            </div>

            {flag && (
                <C2wiInView
                    placementsArray={placementData?.placements}
                    index={selectedIndex}
                    handleFlag={handleFlag}
                />
            )}
        </div>
    );
}

export default C2wPlacemets;
